import { MainKeys } from '../../../main/main.key';
import { Places } from '../../../route-consts';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'si';
/** Os parametros deste place: vao para o endereco. */
const P = {
    /** Para onde o leitor ia quando a porta o parou. */
    Next: `${PREFIX}a`
};
export class SignInKeys extends MainKeys {
    get place() {
        return Places.signIn;
    }
    // :: next
    /** Para onde voltar depois de entrar, quando o leitor foi mandado para ca. */
    get next() {
        return this._intent.getParameterAsString(P.Next);
    }
    set next(value) {
        this._intent.setParameter(P.Next, value ? value : undefined);
    }
}
//# sourceMappingURL=auth.key.js.map